module.exports = __webpack_public_path__ + "static/media/CarsonD.a966fe00.jpg";